<template>
  <div 
    :style="pointStyle" 
    :class="computedClass"
    class="rounded-full bg-primary"
  />
</template>

<script setup lang="ts">
import { computed, ref, onMounted, onUnmounted } from 'vue'

interface Props {
  size?: number
  oscillate?: boolean
  className?: string
}

const props = withDefaults(defineProps<Props>(), {
  size: 8,
  oscillate: false,
  className: ''
})

const scale = ref(1)
let animationId: number | null = null

const computedClass = computed(() => props.className)

const pointStyle = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
  transform: props.oscillate ? `scale(${scale.value})` : 'scale(1)',
  transition: 'transform 0.3s ease-in-out'
}))

const animate = () => {
  if (!props.oscillate) return
  
  const time = Date.now() * 0.002
  scale.value = 1 + Math.sin(time) * 0.3
  
  animationId = requestAnimationFrame(animate)
}

onMounted(() => {
  if (props.oscillate) {
    animate()
  }
})

onUnmounted(() => {
  if (animationId !== null) {
    cancelAnimationFrame(animationId)
  }
})
</script>

<style scoped>
/* Styles additionnels si nécessaire */
</style>

